import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  onChangeField,
  onChangeStories,
  addDeepDiveCoverStory,
  addDeepDiveStory,
} from "deepDiveEditor/actions/form";
// NOTE: reusing styles from StoryEditor
import editorStyles from "../../../editor/containers/StoryEditor/StoryEditor.css";
import styles from "./DeepDiveEditor.css";
import ContentSelector from "components/library/ContentSelector/ContentSelector";
import Label from "components/library/Label/Label";
import SelectedContent from "components/library/SelectedContent/SelectedContent";
import DragDropList from "components/library/DragDropList/DragDropList";
import DragDropItemTypes from "components/library/DragDropList/DragDropItemTypes";
import DeepDiveStory from "../../components/DeepDiveStory/DeepDiveStory";

class DeepDiveEditor extends React.Component {
  constructor() {
    super();
    this.validateContentSelection = this._validateContentSelection.bind(this);
  }

  _validateContentSelection(id) {
    if (
      [...this.props.form.stories, this.props.form.front_cover].includes(id)
    ) {
      return {
        error: "Story is aleady included in selections.",
      };
    }
    return true;
  }

  render() {
    return (
      <div className={editorStyles.root}>
        <div className={editorStyles.top}>
          <div className={editorStyles.container}>
            <div className={styles.storyForm}>
              <Label className={styles.storyFormLabel}>Cover</Label>
              {this.props.form.front_cover ? (
                <SelectedContent
                  content={
                    this.props.form.loadedStories[this.props.form.front_cover]
                  }
                  onRemove={() => this.props.onChangeField("front_cover")(null)}
                />
              ) : (
                <ContentSelector
                  inputId={"add-cover-story"}
                  onContentLookup={this.props.addDeepDiveCoverStory}
                  validateSelection={this.validateContentSelection}
                />
              )}
            </div>
            <div className={styles.storyForm}>
              <Label className={styles.storyFormLabel}>Stories</Label>
              {!!this.props.form.stories.length && (
                <DragDropList
                  items={this.props.form.stories}
                  onReorder={this.props.onChangeStories}
                  itemType={DragDropItemTypes.STORY}
                  renderItem={(item, index) => (
                    <DeepDiveStory
                      storyOrder={index}
                      content={this.props.form.loadedStories[item]}
                      onRemove={() =>
                        this.props.onChangeStories(
                          this.props.form.stories.filter(s => s !== item)
                        )
                      }
                      numberingOverride={this.props.form.numbering_override}
                      onChangePrefix={prefix =>
                        this.props.onChangeField("numbering_override")({
                          ...this.props.form.numbering_override,
                          [item]: prefix,
                        })
                      }
                    />
                  )}
                />
              )}
              <ContentSelector
                inputId={"add-story"}
                validateSelection={this.validateContentSelection}
                onContentLookup={this.props.addDeepDiveStory(
                  this.props.form.stories
                )}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DeepDiveEditor.propTypes = {
  form: PropTypes.object.isRequired,
  onChangeField: PropTypes.func.isRequired,
  fields: PropTypes.array.isRequired,
  onChangeStories: PropTypes.func.isRequired,
  addDeepDiveStory: PropTypes.func.isRequired,
  addDeepDiveCoverStory: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  form: state.deepDiveEditor.form,
  ui: state.deepDiveEditor.ui,
});

const mapDispatchToProps = {
  onChangeField,
  onChangeStories,
  addDeepDiveCoverStory,
  addDeepDiveStory,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeepDiveEditor);
